/**
 *
 * Asynchronously loads the component for Public
 *
 */

import loadable from "loadable-components";

export default loadable(() => import("./index"));
